import { type ItineraryLegDTO } from "../../../../types/dtos/api/itinerary/itinerary.dto";
import { type DynamicIslandHostContext } from "../../dynamicIsland.registry";
import { type DynamicIslandItinerarySummaryPayload } from "../../dynamicIsland.types";

/**
 * Resolves the selected leg object from payload legs and selected id.
 *
 * @param payload Itinerary summary island payload.
 * @returns Matching leg or null when none is selected.
 */
export function resolveItinerarySummarySelectedLeg( payload: DynamicIslandItinerarySummaryPayload ): ItineraryLegDTO | null {
    if ( payload.selectedLegId === null ) {
        return null;
    }

    return payload.legs.find( ( leg ) => leg.id === payload.selectedLegId ) ?? null;
}

/**
 * Forwards a leg chip click to the host when the callback is wired.
 *
 * @param leg Clicked itinerary leg.
 * @param hostContext Host capabilities from the orchestrator.
 */
export function handleItinerarySummaryLegClick(
    leg: ItineraryLegDTO,
    hostContext: DynamicIslandHostContext,
): void {
    hostContext.onItineraryLegClick?.( leg );
}
